import { Component, Input, OnInit } from '@angular/core';
import { schoolData } from 'src/app/core/models/schoolData';
import { ReadingSettingsDataService } from 'src/app/core/services/commonServices/reading-settings-data.service';
import { SchoolDataService } from 'src/app/core/services/school-data.service';

@Component({
  selector: 'app-school-logo-and-name',
  templateUrl: './school-logo-and-name.component.html',
  styleUrls: ['./school-logo-and-name.component.css']
})
export class SchoolLogoAndNameComponent implements OnInit {
  constructor(private readingSettingsData: ReadingSettingsDataService) { }
  doaminName: string = this.readingSettingsData.getSchoolDomain();
  @Input() schoolData = new schoolData();
  ngOnInit(): void {
  }

}
